import { PATH_PERMISSION_DENIED } from "@/constants";
import useAccount from "@/modules/account/hooks/useAccount";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";
import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

export default function AdminGuard({ children }: PropsWithChildren) {
  const { account } = useAccount();

  const isAdmin =
    account?.system_role_code === SYSTEM_ROLE_CODE.SYSTEM_ADMINISTRATOR;

  if (!isAdmin) {
    return <Navigate to={PATH_PERMISSION_DENIED} replace />;
  }

  return children;
}
